module.exports = __webpack_public_path__ + "img/02.36e93a59.jpg";